var cibTed = ["32 32", "<path d='M3.24 13.182h-3.24v-2.964h10.042v2.964h-3.24v8.599h-3.563zM10.594 10.219h9.745v2.964h-6.182v1.443h6.182v2.75h-6.182v1.443h6.182v2.964h-9.745zM24.5 18.823h1.396c2.219 0 2.542-1.802 2.542-2.891 0-0.724-0.24-2.75-2.818-2.75h-1.141v5.641zM20.938 10.219h5.849c3.854 0 5.214 2.849 5.214 5.76 0 3.547-1.88 5.802-5.911 5.802h-5.151z'/>"];

export { cibTed };

